const throttle = 1000;
let scrollTimeout;
let isLoading = false;

var scrollMessage = function () {
  const productGridContainer = document.getElementById("collection-product-grid");
  const containerBottomYCoordinate = productGridContainer.offsetTop + productGridContainer.offsetHeight;
  const windowOffset = window.outerHeight / 2;

  if (window.scrollY + windowOffset > containerBottomYCoordinate) {
    loadMoreProducts();
  }
};

$(window).on("scroll", function () {
  if (!scrollTimeout) {
    scrollTimeout = setTimeout(function () {
      scrollMessage();
      scrollTimeout = null;
    }, throttle);
  }
});

function loadMoreProducts() {
  if (isLoading === true) {
    return;
  }

  const $this = $(this);
  const totalPages = parseInt($("[data-total-pages]").val());
  const currentPage = parseInt($("[data-current-page]").val());
  const nextUrl = $("[data-next-url]")
    .val()
    .replace(/page=[0-9]+/, "page=" + (currentPage + 1));
  $("[data-current-page]").val(currentPage + 1);

  isLoading = true;

  if (currentPage >= totalPages) {
    // hide the load more button
    document.getElementById("pagination-load-more-btn").style.display = "none";

    return;
  }

  document.getElementById("pagination-loading-message").style.display = "block";

  $.ajax({
    url: nextUrl,
    type: "GET",
    dataType: "html",
    success: function (responseHTML) {
      const test = $(".productgrid--items").append($(responseHTML).find(".productgrid--items").html());
    },
    complete: function () {
      if (currentPage <= totalPages) {
        $this.attr("disabled", false);
        $this.find("[load-more-text]").removeClass("hide");
        $this.find("[loader]").addClass("hide");
      }
      isLoading = false;
      document.getElementById("pagination-loading-message").style.display = "none";
    },
  });
}
